<div class="profile-page" [class.profile-page-initial]="isInitialProfileFlow">
  <div class="profile-shell" [class.profile-shell-initial]="isInitialProfileFlow">
    <div class="profile-header" [class.profile-header-initial]="isInitialProfileFlow">
      <h1>{{ isInitialProfileFlow ? 'Complete your profile' : 'Profile' }}</h1>
      <p *ngIf="isInitialProfileFlow" class="profile-subtitle">
        Add the basics so we can finish setting up your account.
      </p>
    </div>

    <form class="form" [formGroup]="form">
        <div class="photo">
          <img #avatar class="icon" (click)="takePicture()">
          <input #camerainput type="file" style="display: none;" accept="image/*" (change)="changePhoto($event)">
          <div class="image-actions">
              <button mat-stroked-button type="button" [disabled]="uploading" class="image-action-button image-action-button-primary" (click)="takePicture()">Change Profile Image</button>
              <button mat-button type="button" [disabled]="uploading" class="image-action-button image-action-button-secondary" (click)="clearAvatar()">Remove Profile Image</button>
          </div>
        </div>
        <mat-form-field hintLabel="Max 50 characters">
            <mat-label>First Name</mat-label>
            <input matInput #input maxlength="50" placeholder="" formControlName="firstname">
            <mat-hint align="end">{{input.value.length || 0}}/50</mat-hint>
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters">
            <mat-label>Last Name</mat-label>
            <input matInput #input2 maxlength="50" placeholder="" formControlName="lastname">
            <mat-hint align="end">{{input2.value.length || 0}}/50</mat-hint>
        </mat-form-field>
        <mat-form-field hintLabel="Max 50 characters">
            <mat-label>Nickname</mat-label>
            <input matInput #input3 maxlength="50" placeholder="" formControlName="nickname">
            <mat-hint align="end">{{input3.value.length || 0}}/50</mat-hint>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Date of Birth</mat-label>
          <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="dob">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <ng-container *ngIf="!isInitialProfileFlow">
          <mat-form-field>
              <mat-label>Address 1</mat-label>
              <input matInput placeholder="" formControlName="address1">
          </mat-form-field>
          <mat-form-field>
              <mat-label>Address 2</mat-label>
              <input matInput placeholder="" formControlName="address2">
          </mat-form-field>
          <mat-form-field>
              <mat-label>City</mat-label>
              <input matInput placeholder="" formControlName="city">
          </mat-form-field>
          <mat-form-field>
              <mat-label>State</mat-label>
              <app-state formControlName="state"></app-state>
          </mat-form-field>
          <mat-form-field>
              <mat-label>Zip Code</mat-label>
              <input matInput placeholder="" formControlName="postalCode">
          </mat-form-field>
        </ng-container>
        <mat-form-field *ngIf="!isInitialProfileFlow">
            <mat-label>SSN</mat-label>
            <div class="ssn-field">
                <input matInput placeholder="*** ** ****" formControlName="ssn" [type]="hideSsn ? 'password' : 'text'">
                <mat-icon class="hide-password-icon" [svgIcon]="hideSsn ? 'icon-eye-lock' : 'icon-eye'" (click)="hideSsn = !hideSsn"></mat-icon>
            </div>
        </mat-form-field>

        <mat-form-field hintLabel="me@example.com">
            <mat-label>Email</mat-label>
            <input matInput #input3  placeholder="" formControlName="email">
        </mat-form-field>
    </form>
    <section class="roles-section">
      <h2>Assigned Roles</h2>
      <div *ngIf="currentUserRolesLoading" class="roles-status">Loading roles...</div>
      <div *ngIf="!currentUserRolesLoading && currentUserRolesError" class="roles-status roles-error">{{currentUserRolesError}}</div>
      <div *ngIf="!currentUserRolesLoading && !currentUserRolesError && currentUserRoles.length === 0" class="roles-status">No roles assigned.</div>
      <div *ngIf="!currentUserRolesLoading && !currentUserRolesError && currentUserRoles.length > 0" class="roles-list">
        <div *ngFor="let role of currentUserRoles" class="role-item">
          <span class="role-name">{{getRoleLabel(role.role)}}</span>
          <span class="role-company">{{role.name}}</span>
        </div>
      </div>
    </section>
    <button mat-raised-button color="primary" class="primarybutton" shape="" type="submit" [disabled]="!form.valid || !form.dirty" (click)="saveClicked($event)">Save</button>
  </div>
</div>
